
function notify(e) {
    if (e == "Unable to find address")
    {
        $(".result-list-intro").remove();
    }
}

function searchCount(resultCount, search) {
    $(".result-list-intro").remove();
    $(".bh-sl-noresults-title").hide();
    if (search != undefined) {
        search = search.charAt(0).toUpperCase() + search.substr(1).toLowerCase()
    }

    var bij = (resultCount > 1) ? "Bijouteries correspondent" : "Bijouterie correspond";
    
    var html = "<p class=\"result-list-intro\"><strong>" + resultCount + "</strong> " + bij + "<br> à votre RECHERCHE";
    html += (search != undefined) ? ":<br> <strong>&laquo;" + search + "&raquo;</strong>" : ":<br> <strong>Toutes les bijouteries</strong></p>";
    $(".bh-sl-loc-list").parent().prepend(html);
}

var mamap;
$(function () {
    mamap = $('#bh-sl-map-container').storeLocator({
        'slideMap': false,
        //'defaultLoc': false,
        //'defaultLat': '47.2384079',
        //'defaultLng': '5.9932964',
        'markerImg': '/Content/storeLocator/geo-marker.png',
        'markerDim': { height: 32, width: 32 },
        'infowindowTemplatePath': '/Content/storeLocator/templates/infowindow-description.txt',
        'listTemplatePath': '/Content/storeLocator/templates/location-list-description.txt',
        'KMLinfowindowTemplatePath': '/Content/storeLocator/templates/kml-infowindow-description.txt',
        'KMLlistTemplatePath': '/Content/storeLocator/templates/kml-location-list-description.txt',
        //'dataLocation': '/Content/storelocator/locations.xml',
        'nameSearch': true,
        'dataLocation': '/jewellery/GetStoreLocations',
        'dataType' : 'json',
        'visibleMarkersList': false,
        'autoGeocode':false,
        'noForm': true,
        'querystringParams': true,  // Ne fonctionne que si FullMapStart actif
        'fullMapStart': true,
        'storeLimit': -1,   // Sinon sur Carte complète, on n'aura pas toutes les bijouteries... 
        'lengthUnit': 'km',
        'kilometerLang': 'Km',
        'kilometersLang': 'Km',
        'inlineDirections': false,
        'debug': false,
        'maxDistance': true,
        'noResultsTitle': 'Aucune bijouterie ne correspond <br>à votre recherche.',
        'noResultsDesc': '',
        //'maxDistanceID': 'bh-sl-maxdistance',
        'listColor1': '#fff',
        'listColor2': '#fff',
        'distanceAlert': -1,
        'callbackNotify': notify,
        'callbackStoreNum': searchCount,
        'mapSettings': {zoom:0} // Pour forcer la carte a dézoomer sur tous les marqueurs trouvés plutôt que sur la ville cherchée (ex. Epeugney : sans ce param, le zoom sera centré sur la commune et tellement serré qu'on ne verra pas les marqueurs sur Besançon, Dijon, etc... )
      });
  });

// Exécuté au lancement de l'application
$(function () {
    var openingHours = new OpeningHours($("[data-opening]"));
    // Initialisation du carrousel 
    $("#WITHPREVIEW").owlCarousel({
        center: true,
        items: 1,
        nav: true,
        autoplay: true,
        loop: ($("#WITHPREVIEW .item").length > 1),
        stagePadding: 5,
        margin: 16,
        navText: ["4","5"],
        responsive: {
            0: {
                stagePadding: 16
            },
            300: {
                stagePadding: 16
            },
            600: {
                stagePadding: 30,
                margin: 20
            },
            960: {
                stagePadding: 30,
                margin: 20
            }
        }
    });
}); 
